import React from "react";
import { FiTrash } from "react-icons/fi";
import { RiPencilFill } from "react-icons/ri";
import Moment from "react-moment";
import { ButtonA } from "../../styles-components/Buttons";

import {
  LiColumnList,
  TitleColumnList,
  UlColumnList,
} from "../../styles-components/ColumnList";

const ItemColumnList = ({
  date,
  description,
  handleShowFormEdit,
  onDelete,
  children,
  isEditing,
}) => {
  return (
    <UlColumnList>
      <LiColumnList>
        <TitleColumnList>
          <Moment format="DD/MM/YYYY">{date}</Moment>
        </TitleColumnList>
        <ul>
          <li>
            <p>{description}</p>
            <section>
              <ButtonA
                color="--white"
                backgroundColor="--light-fake-blue"
                onClick={handleShowFormEdit}
              >
                <RiPencilFill size={20} />
              </ButtonA>
              <ButtonA
                color="--white"
                backgroundColor="--red"
                onClick={onDelete}
              >
                <FiTrash size={20} />
              </ButtonA>
            </section>
          </li>
          {isEditing !== null && <li>{children}</li>}
        </ul>
      </LiColumnList>
    </UlColumnList>
  );
};

export default ItemColumnList;
